module.exports = __webpack_public_path__ + "media/maids/20-c98eacd0.gif";